module.exports = __webpack_public_path__ + "img/box-06.ce0160aa.jpeg";